import { defineComponent as _defineComponent } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'FpTooltip',
  props: {
    text: null,
    title: null,
    nudgeTop: null,
    maxWidth: null,
    showTooltip: { type: Boolean, default: true }
  },
  setup(__props: any) {

const props = __props as { text?: string, title?: string, nudgeTop?: number | string, maxWidth?: string, showTooltip: boolean }



return { __sfc: true,props }
}

})